export var AuthLayout;
(function (AuthLayout) {
    AuthLayout["AUTH_FULL"] = "AUTH:FULL";
    AuthLayout["AUTH_CONDENSED"] = "AUTH:CONDENSED";
    AuthLayout["EXTERNAL_FULL"] = "EXTERNAL:FULL";
    AuthLayout["EXTERNAL_CONDENSED"] = "EXTERNAL:CONDENSED";
})(AuthLayout || (AuthLayout = {}));
